// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-quicksearch__wrapper[data-v-f124cf76]{position:relative;max-width:800px}.global-quicksearch__wrapper[data-v-f124cf76] .input__input:focus{outline:none}.close-icon[data-v-f124cf76]{right:8px;top:8px}", ""]);
// Exports
module.exports = exports;
